import { render, staticRenderFns } from "./ClaimsDiagnosesChart.vue?vue&type=template&id=659c84ed&"
import script from "./ClaimsDiagnosesChart.vue?vue&type=script&lang=js&"
export * from "./ClaimsDiagnosesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports